// 중복 안내 다이얼로그 (차량번호 / 매물 링크) — 데스크톱 센터, ≤768 바텀시트(SheetFrame).
// 버튼: [닫기] [신청 내역 보기]. 서버 error 문자열의 주문번호는 파싱하지 않는다.
import React from 'react';
import { T, R } from '../../../theme';
import { SheetFrame } from '../../parts/ConfirmSheet';

var headline = { fontSize: 14, fontWeight: 800, letterSpacing: '-.25px', color: T.ink };
var sub = { fontSize: 12, color: T.muted, marginTop: 3, lineHeight: 1.6 };
var row = { display: 'flex', gap: 10 };
var btn = { flex: 1, height: 42, borderRadius: R.md, fontSize: 13.5, fontWeight: 700, cursor: 'pointer',
  fontFamily: 'inherit', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', minWidth: 0 };

function DupDialog(props) {
  var t = props.t;
  if (!props.open) return null;
  return (<SheetFrame open title={props.title} onClose={props.onClose} closeLabel={t('actionClose')}>
    <div>
      <div style={headline}>{props.title}</div>
      <p style={sub}>{props.sub}</p>
    </div>
    <div style={row}>
      <button type="button" style={Object.assign({}, btn, { background: T.card, border: '1px solid ' + T.bd, color: T.body })}
        onClick={props.onClose}>{t('actionClose')}</button>
      <button type="button" data-testid="dup-view"
        style={Object.assign({}, btn, { background: T.navy, border: '1px solid ' + T.navy, color: T.card, flex: 2 })}
        onClick={props.onView}>{t('simpleDupView')}</button>
    </div>
  </SheetFrame>);
}

export default DupDialog;
